import React, { Component } from 'react'

import { Button, Icon, withMobile } from 'component-library-next'

import DocumentItem from '@app/modules/Messages/Components/DocumentItem'
import { DocumentUploadPopupLawyer } from '@app/modules/Messages/Components/DocumentUploadPopupLawyer/DocumentUploadPopupLawyer'
import { UploadDropzone } from '@app/modules/Messages/Components/UploadDropzone'
import { UploadLetterDropzone } from '@app/modules/Messages/Components/UploadLetterDropzone'
import { letterRequestContext } from '@app/modules/Messages/letterRequestContext'

import './styles.scss'

class AddDocuments extends Component {
  state = {
    file: null,
    letter: null,
    showUploadPopup: false,
    showUploadLetterPopup: false
  }

  addFile = (file) => {
    this.setState({
      file: file[0],
      showUploadPopup: true
    })
  }

  addLetter = (file) => {
    this.setState({
      letter: file[0],
      showUploadLetterPopup: true
    })
  }

  hidePopup = () => {
    this.setState({
      showUploadPopup: false,
      showUploadLetterPopup: false,
      file: null
    })
  }

  render() {
    const {
      mobile,
      onUploadDoc,
      selectedDocuments,
      selectedLetterId,
      onSelectedDocRemove,
      onLetterSelectedDocRemove,
      documents
    } = this.props

    const { showUploadPopup, showUploadLetterPopup, file, letter } = this.state
    const docsToRender = documents.filter((doc) => selectedDocuments.some((id) => id === doc.id))
    const lettersToRender = documents.filter((doc) => doc.id === selectedLetterId)

    return (
      <letterRequestContext.Consumer>
        {({ letterRequestData }) => (
          <div className='file-attach'>
            {lettersToRender.length > 0 && (
              <div>
                <ul className='add-documents__documents-list'>
                  {lettersToRender.map((doc) => {
                    return (
                      <DocumentItem key={doc.id} doc={doc} tryDelete={onLetterSelectedDocRemove} />
                    )
                  })}
                </ul>
              </div>
            )}

            {selectedDocuments.length > 0 && (
              <div>
                <ul className='add-documents__documents-list'>
                  {docsToRender.map((doc) => {
                    return <DocumentItem key={doc.id} doc={doc} tryDelete={onSelectedDocRemove} />
                  })}
                </ul>
              </div>
            )}

            {mobile && letterRequestData && letterRequestData.openLetterRequest ? (
              <h3 className='add-documents__title'>Wählen Sie einen Dokumententyp aus</h3>
            ) : (
              mobile && (
                <p className='file-attach-info'>
                  Hängen Sie Dokumente an Ihre Nachricht an. Diese werden gemeinsam mit Ihrer
                  Antwort an den Mandanten geschickt.
                </p>
              )
            )}

            {!mobile && (
              <div>
                {letterRequestData && letterRequestData.openLetterRequest && (
                  <div>
                    <h3 className='add-documents__title'>Wählen Sie einen Dokumententyp aus</h3>
                    <div className='dropzone-wrap'>
                      <UploadLetterDropzone onUpload={this.addLetter} />
                    </div>
                  </div>
                )}
                <div className='dropzone-wrap'>
                  <UploadDropzone onUpload={this.addFile} />
                </div>
              </div>
            )}

            {mobile && (
              <div>
                {letterRequestData && letterRequestData.openLetterRequest && (
                  <div
                    className={'mobile-upload-grid'}
                    onClick={() => this.setState({ showUploadLetterPopup: true })}
                  >
                    <div>
                      <Button shape={Button.shapes.Circle} color={Button.colors.premium}>
                        <Icon alt='add' name={Icon.names.plus} />
                      </Button>
                    </div>
                    <p>Kopie Ihres Anwaltsschreibens</p>
                  </div>
                )}
                <div
                  className={'mobile-upload-grid'}
                  onClick={() => this.setState({ showUploadPopup: true })}
                >
                  <div>
                    <Button shape={Button.shapes.Circle}>
                      <Icon alt='add' name={Icon.names.plus} />
                    </Button>
                  </div>
                  <p>Weitere Dokumente</p>
                </div>
              </div>
            )}

            {showUploadPopup && (
              <DocumentUploadPopupLawyer
                file={file}
                onSubmit={(formData) => {
                  onUploadDoc({ formData, letter: false })
                  this.hidePopup()
                }}
                setFile={this.addFile}
                onClose={this.hidePopup}
                onRemoveFile={() => this.setState({ file: null })}
              />
            )}

            {showUploadLetterPopup && (
              <DocumentUploadPopupLawyer
                hasLetter={true}
                file={letter}
                onSubmit={(formData) => {
                  onUploadDoc({ formData, letter: true })
                  this.hidePopup()
                }}
                setFile={this.addLetter}
                onClose={this.hidePopup}
                onRemoveFile={() => this.setState({ letter: null })}
              />
            )}
          </div>
        )}
      </letterRequestContext.Consumer>
    )
  }
}

export default withMobile(AddDocuments)
